import React from 'react';
import _ from 'lodash';
import Griddle from 'griddle-react';
import {Map} from 'immutable';
import {Row, Col} from 'react-bootstrap';
import {PermissionRequired, TableSearch, PageTitle, Loader, Oops, NoItemHelper} from '../../components';
import {search} from '../../components/TableSearch/TableSearch';
import {PriceAlertsAction} from '../../actions';
import {Activities} from '../../constants';
import {PriceAlertsStore} from '../../stores';
import {PageError, PageHelper, PageLifcycle, PageLoaded, PageLoading} from '../PageLifecycle';
import BulkActionsToolbar from './BulkActionsToolbar';

/**
 * Select All Checkbox Component
 */
const SelectAllCheckbox = React.createClass({
  render() {
    const {selectedAlertIds, priceAlerts, onToggleSelectAll} = this.props;
    const selectableAlerts = priceAlerts.filter(a => a.status === 'new');
    const selectedCount = selectableAlerts.filter(a => selectedAlertIds.includes(a.id)).length;
    const allSelected = selectableAlerts.length > 0 && selectedCount === selectableAlerts.length;

    if (selectableAlerts.length === 0) {
      return null;
    }

    return (
      <label style={{
        position: 'absolute', 
        display: 'flex', 
        alignItems: 'flex-start', 
        margin: 0, 
        cursor: 'pointer', 
        fontWeight: 'normal',
        fontSize: '14px',
        color: '#555',
        whiteSpace: 'nowrap'
      }}>
        <input
          type="checkbox"
          checked={allSelected}
          onChange={onToggleSelectAll}
          style={{marginTop: '3px', marginRight: '6px', cursor: 'pointer'}}
        />
        <span>Select All ({selectableAlerts.length})</span>
      </label>
    );
  }
});

export default React.createClass({
  propTypes: {
    priceAlerts:       React.PropTypes.array,
    supplier:          React.PropTypes.object,
    contractInfo:      React.PropTypes.object,
    loadingStatus:     React.PropTypes.object,
    selectedAlertIds:  React.PropTypes.array,
    onBulkSkip:        React.PropTypes.func,
    onClearSelection:  React.PropTypes.func,
    onToggleSelectAll: React.PropTypes.func
  },

  getDefaultProps: function () {
    return {
      priceAlerts:      [],
      selectedAlertIds: [],
      loadingStatus: Map({
        status:  'loading',
        message: 'Fetching data from server. Please wait.',
      })
    }
  },

  getInitialState() {
    return {
      priceAlerts: this.augmentAlertsWithSelection(this.props.priceAlerts, this.props.selectedAlertIds)
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    const shouldUpdate = !_.isEqual(nextProps.priceAlerts, this.props.priceAlerts)
      || this.props.loadingStatus.get('status') !== nextProps.loadingStatus.get('status')
      || !_.isEqual(nextProps.selectedAlertIds, this.props.selectedAlertIds)
      || !_.isEqual(nextProps.searchParams, this.props.searchParams);
    return shouldUpdate;
  },

  componentWillReceiveProps(nextProps) {
    // Save scroll position before updating
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (nextProps.searchParams.size > 0) {
      let filteredAlerts = search([...nextProps.priceAlerts], nextProps.searchParams.toJS())
      this.setState({priceAlerts: this.augmentAlertsWithSelection(filteredAlerts, nextProps.selectedAlertIds)}, () => {
        // Restore scroll position after state update
        window.scrollTo(0, scrollTop);
      })
    } else {
      this.setState({priceAlerts: this.augmentAlertsWithSelection(nextProps.priceAlerts, nextProps.selectedAlertIds)}, () => {
        // Restore scroll position after state update
        window.scrollTo(0, scrollTop);
      })
    }
  },

  /**
   * Add selection state to each alert to force Griddle to re-render
   */
  augmentAlertsWithSelection(alerts, selectedAlertIds = []) {
    return alerts.map(alert => ({
      ...alert,
      select: alert.id,  // Dummy value for the select column
      _isSelected: selectedAlertIds.includes(alert.id)
    }));
  },

  componentWillUnmount() {
    PriceAlertsStore.setState({ search: Map() });
  },

  /**
   * Calculate alert counts by status
   * @returns {object} Counts for each status
   */
  getAlertCounts() {
    const alerts = this.state.priceAlerts;
    return {
      total: alerts.length,
      new: alerts.filter(a => a.status === 'new').length,
      resolved: alerts.filter(a => a.status === 'resolved').length,
      skipped: alerts.filter(a => a.status === 'skipped').length,
      invalid: alerts.filter(a => a.status === 'invalid').length
    };
  },

  /**
   * Format date for display
   */
  formatDate(date) {
    if (!date) return 'N/A';
    return require('moment')(date).format('YYYY-MM-DD');
  },

  render() {
    const isLoading = this.props.loadingStatus.get('status') === 'loading';
    const isError = this.props.loadingStatus.get('status') === 'error';
    const hasItems = this.props.priceAlerts.length > 0;
    const {supplier, contractInfo} = this.props;
    const counts = this.getAlertCounts();
    
    return (
      <PermissionRequired requiredRoles={Activities.READ_PRICES} user={this.props.user}>
        <PageTitle>Price Alerts</PageTitle>
        
        {/* Display supplier and contract info if available */}
        {supplier && (
          <form className="form-horizontal details-wrapper">
            <Row>
              <Col xs={12} style={{textAlign: 'center'}}>
                <label style={{fontSize: '20px', fontWeight: 'bold', marginRight: '10px'}}>Supplier:</label>
                <span style={{fontSize: '20px'}}>{supplier.name}</span>
              </Col>
            </Row>
            
            {/* Contract information row */}
            {contractInfo && (
              <Row style={{marginTop: '10px'}}>
                <Col xs={12} style={{textAlign: 'center', fontSize: '15px'}}>
                  <span style={{marginRight: '30px'}}>
                    <strong>Contract Type:</strong> {contractInfo.isPublic ? 'Secondary' : 'Primary'}
                  </span>
                  <span>
                    <strong>Date of Load:</strong> {this.formatDate(contractInfo.createdAt)}
                  </span>
                </Col>
              </Row>
            )}
            
            <Row style={{marginTop: '15px'}}>
              <Col xs={12} style={{textAlign: 'center', fontSize: '16px'}}>
                <span style={{marginRight: '25px', fontWeight: 'bold'}}>
                  <strong>Total:</strong> {counts.total}
                </span>
                <span style={{marginRight: '25px', color: '#d9534f', fontWeight: 'bold'}}>
                  <strong>New:</strong> {counts.new}
                </span>
                <span style={{marginRight: '25px', color: '#5cb85c', fontWeight: 'bold'}}>
                  <strong>Resolved:</strong> {counts.resolved}
                </span>
                <span style={{marginRight: '25px', color: '#5bc0de', fontWeight: 'bold'}}>
                  <strong>Skipped:</strong> {counts.skipped}
                </span>
                <span style={{color: '#999', fontWeight: 'bold'}}>
                  <strong>Invalid:</strong> {counts.invalid}
                </span>
              </Col>
            </Row>
          </form>
        )}
        
        <PageLifcycle>
          {/* Displaying when page loading */}
          <PageLoading isDisplayed={isLoading}>
            <Loader>
              {this.props.loadingStatus.get('message') || 'Fetching price alerts from server. Please wait.'}
            </Loader>
          </PageLoading>

          {/* Displaying when error */}
          <PageError isDisplayed={isError}>
            <Oops />
          </PageError>

          {/* Displaying when no items */}
          <PageHelper isDisplayed={!isError && !isLoading && !hasItems}>
            <NoItemHelper>
              <p>There are no price alerts at the moment.</p>
              <p>Alerts are automatically generated when prices change by more than 10%.</p>
            </NoItemHelper>
          </PageHelper>

          {/* Displaying when page loaded */}
          <PageLoaded isDisplayed={!isError && !isLoading && hasItems}>
            <div style={{marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
              <div style={{display: 'flex', gap: '15px', alignItems: 'center'}}>
                <SelectAllCheckbox
                  selectedAlertIds={this.props.selectedAlertIds || []}
                  priceAlerts={this.state.priceAlerts}
                  onToggleSelectAll={this.props.onToggleSelectAll}
                />
                <TableSearch
                  user={this.props.user}
                  requiredRoles={Activities.READ_PRICES}
                  columnMetadata={this.props.columnMetadata}
                  onSearch={this.handleSearch}
                />
              </div>
              <BulkActionsToolbar
                selectedCount={(this.props.selectedAlertIds || []).length}
                onBulkSkip={this.props.onBulkSkip}
                onClearSelection={this.props.onClearSelection}
              />
            </div>
            <Griddle
              initialSort="createdAt"
              initialSortAscending={false}
              results={this.state.priceAlerts}
              tableClassName="table middle-td"
              resultsPerPage={20}
              filterPlaceholderText="Search"
              columnMetadata={this.props.columnMetadata}
              columns={this.props.columnNames}
            />
          </PageLoaded>
        </PageLifcycle>
      </PermissionRequired>
    )
  },

  handleSearch(e) {
    let {name, value} = e.target;
    PriceAlertsAction.search(name, value);
  }
});
